import {useTheme} from "@mui/material/styles";
import {Box, Grid, InputLabel, TextField} from "@mui/material";
import {LinksIconMenu} from "../resources/LinksIconMenu";
import React from "react";
import BasePage from "../../baseComponents/BasePage";

export const ContactUs = () => {
  const theme = useTheme();
  return (
    <BasePage>
      <Box width={'100%'} display={'flex'} justifyContent={'flex-end'}>
        <LinksIconMenu sx={{width: 100, justifyContent: 'right'}}/>
      </Box>
      <Box
        width={'100%'}
        sx={{
          p: 4,
          borderRadius: '8px',
          bgcolor: 'white',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: `
            inset 6px 6px 8px rgba(0, 0, 0, 0.3),
            inset -6px -6px 8px rgba(255, 255, 255, 0.5)
          `,
        }}
      >
        <Grid container spacing={1}
                    justify="flex-start"
      alignItems="stretch"
        >
          <Grid item xs={12}>
            <InputLabel>
              Name
            </InputLabel>
            <TextField
              type={'text'}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel>
              Email
            </InputLabel>
            <TextField
              type={'text'}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel>
              Organization
            </InputLabel>
            <TextField
              type={'text'}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} height={'12em'}>
            <InputLabel>
              Message
            </InputLabel>
            <TextField
              type={'text'}
              fullWidth
              multiline
              placeholder={"Your message here..."}

              rows={6}
              sx={{
                // flex: 1,
                '& .MuiInputBase-root': { height: '20em', p:1, width: '100%' },
                '& .MuiInputBase-inputMultiline': { height: '20em' },
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </BasePage>
  );
}